import React from "react";
import PropTypes from "prop-types";
import { DropTarget } from "react-dnd";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import { firebaseConnect } from "react-redux-firebase";
import { push } from "react-router-redux";
import { withRouter } from "react-router";

import ActionCreators from "../../redux/actions";
import Types from "../../dnd/types";
import { target, collect } from "../../dnd/jumper";
import { Player } from "../../components/Player";
import LoadingOverlay from "../../components/LoadingOverlay";

class PlayerContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      hoverPosition: { x: 0, y: 0 }
    };
    this.onWidgetMoveEnd = this.onWidgetMoveEnd.bind(this);
    this.addWidget = this.addWidget.bind(this);
  }

  updateHoverPosition(position) {
    this.setState({ hoverPosition: position });
  }
  componentWillReceiveProps(nextProps) {
    if (!nextProps.playerProject && nextProps.projectRequested) {
      this.props.history.push("/not-found");
    }
  }

  onWidgetMoveEnd(widgetId, phi, theta) {
    const { projectId, sceneId, layerId } = this.props.match.params;
    const path = `/projects/${projectId}/scenes/${sceneId}/layers/${layerId}/widgets/${widgetId}`;
    this.props.firebase.update(path, {
      phi: phi,
      theta: theta
    });
    this.props.firebase.remove(
      `/projects/${projectId}/scenes/${sceneId}/layers/${layerId}/widgets/${widgetId}/dropPosition`
    );
  }

  addWidget(item, position) {
    if (this.props.playerProject.prefabs[item.id] && this.props.onPrefabDrop) {
      this.props.onPrefabDrop(item.id, position);
    }
  }

  render() {
    const { connectDropTarget } = this.props;
    if (!this.props.playerProject) {
      return <LoadingOverlay />;
    }
    return connectDropTarget(
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          zIndex: 0,
          flex: 1
        }}
      >
        {this.props.playerProject && (
          <Player
            editor={this.props.editor || false}
            project={this.props.playerProject}
            sceneId={this.props.match.params.sceneId}
            layerId={this.props.match.params.layerId}
            projectId={this.props.match.params.projectId}
            selectInspectorItem={this.props.selectInspectorItem}
            onWidgetMoveEnd={this.onWidgetMoveEnd}
            push={this.props.push}
            inEditor={this.props.inEditor}
            match={this.props.match}
          />
        )}
      </div>
    );
  }
}
PlayerContainer.defaultProps = {
  playerProject: null
};

PlayerContainer.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  playerProject: PropTypes.shape()
};

PlayerContainer.defaultProps = {};

function mapStateToProps({ firebase, router, editor, map }) {
  return {
    playerProject: firebase.data.playerProject,
    projectRequested: firebase.requested.playerProject
  };
}
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(ActionCreators, dispatch),
  push: path => {
    dispatch(push(path));
  }
});

export default compose(
  withRouter,
  connect(({ firebase }) => ({
    auth: firebase.auth
  })),
  firebaseConnect(props => [
    {
      path: `/projects/${props.match.params.projectId}`,
      storeAs: "playerProject"
    }
  ]),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  DropTarget(Types.WIDGET, target, collect)
)(PlayerContainer);



// WEBPACK FOOTER //
// ./src/containers/PlayerContainer/PlayerContainer.js